import React, { memo } from 'react';
import IconMC from '../../../components/IconMC';

/**
 * CheckedIconMC - Atom Component (Inbox Module)
 *
 * Checkbox visual para indicar si está activo o no (solo check/no check)
 * No realiza selección/deselección de todo, solo muestra el estado visual
 *
 * @param {boolean} checked - Si el checkbox está activo (check)
 * @param {function} onToggle - Callback al hacer click
 * @param {string} className - Clases CSS adicionales
 */
const CheckedIconMC = memo(({ checked, onToggle, className = '' }) => (
  <div
    className={`tw-w-4 tw-h-4 tw-border tw-border-gray-300 tw-rounded tw-flex-shrink-0 tw-cursor-pointer tw-flex tw-items-center tw-justify-center hover:tw-border-blue-400 tw-transition-colors ${className}`}
    onClick={onToggle}
  >
    {checked && (
      <div className="tw-w-3 tw-h-3 tw-bg-blue-500 tw-rounded tw-flex tw-items-center tw-justify-center">
        <IconMC
          name="checkmark-outline"
          size="xs"
          className="tw-text-white"
        />
      </div>
    )}
  </div>
));

CheckedIconMC.displayName = 'CheckedIconMC';

export default CheckedIconMC;
